import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
    container: {
        display: "flex",
        width: "100%",
        padding: "-1px"
    },
    title: {
        fontSize: "15px",
        color: theme.palette.warning.light,
    },
    value: {
        textAlign: "left",
        fontSize: "13px",
    },
    clickableText: {
        color: "lightblue",
        cursor: "pointer",
        display: "inline-block",
        marginLeft: "5px",
        fontSize: "14px",
    },
    detailsText: {
        display: "-webkit-box",
        overflow: "hidden",
        WebkitLineClamp: 2,
        textOverflow: "ellipsis",
        wordBreak: "break-word",
        whiteSpace: "normal",
        fontSize: "14px",
    },
    eventIconContainer: {
        position: "relative",
        display: "inline-block",
        width: 20,
        height: 20,
    },
}));

export const getEventIconStyles = (color: string, index: number) => ({
    backgroundColor: color,
    border: `2px solid ${color}`,
    width: 16,
    height: 16,
    color: "white",
    position: "absolute",
    left: index * 10,
    zIndex: 10 - index,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "10px",
    fontWeight: 500,
});

export default useStyles;
